import React, { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Info_video from "../assets/hero.mp4";
import Paramveer from "../assets/Paramveer.jpeg"
import Ritik from "../assets/Ritik.png"
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaRocket, FaUsers, FaChartLine } from 'react-icons/fa';

const LeadershipCard = ({ name, role, description, image, delay, isReversed }) => (
  <div
    className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-center"
    data-aos={isReversed ? "fade-left" : "fade-right"}
    data-aos-delay={delay}
  >
    {/* Image Section */}
    <div className={`order-1 ${isReversed ? 'md:order-2' : 'md:order-1'}`}>
      <div className="relative md:max-w-[250px] lg:max-w-[300px] mx-auto w-full overflow-hidden rounded-xl transition-transform duration-300 hover:scale-110">
        <div className="relative pb-[125%]">
          <img
            src={image}
            alt={name}
            className="absolute inset-0 w-full h-full object-cover rounded-xl"
          />
        </div>
      </div>
    </div>

    {/* Content Section */}
    <div className={`order-2 ${isReversed ? 'md:order-1' : 'md:order-2'}`}>
      <div className="flex flex-col space-y-2">
        <h3 className="text-2xl font-bold text-white/95">{name}</h3>
        <p className="text-orange-500 font-semibold">{role}</p>
        <p className="text-white/70 leading-relaxed">{description}</p>
      </div>
    </div>
  </div>
);

const OurStory = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      <main>
        {/* Hero Section with Video Background */}
        <section className="relative h-[60vh] sm:h-[70vh] lg:h-[80vh] overflow-hidden">
          {/* Subtle background glow (theme match) */}
          <div className="absolute inset-0 pointer-events-none" style={{ zIndex: 0 }}>
            <div className="absolute -top-40 left-1/2 h-[32rem] w-[32rem] -translate-x-1/2 rounded-full bg-orange-500/15 blur-3xl" />
            <div className="absolute -bottom-40 left-1/3 h-[30rem] w-[30rem] -translate-x-1/2 rounded-full bg-blue-500/10 blur-3xl" />
          </div>
          <video
            className="absolute inset-0 w-full h-full object-cover"
            autoPlay
            loop
            muted
            playsInline
            style={{ zIndex: 0 }}
          >
            <source src={Info_video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/80" style={{ zIndex: 1 }} />
          <div className="relative z-10 h-full container mx-auto px-2 md:px-4 lg:px-8">
            <div className="flex flex-col items-center justify-center h-full text-center">
              <h1
                className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6"
                data-aos="fade-down"
              >
                Our Journey
              </h1>
              <p
                className="text-xl sm:text-2xl md:text-3xl text-white max-w-3xl mx-auto leading-relaxed"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                From a vision to a revolution in influencer marketing
              </p>
            </div>
          </div>
        </section>

        {/* Mission Statement Section */}
        <section className="relative overflow-hidden py-16 sm:py-20 lg:py-24 bg-black">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute -top-44 left-1/3 h-[30rem] w-[30rem] -translate-x-1/2 rounded-full bg-orange-500/10 blur-3xl" />
            <div className="absolute -bottom-44 left-2/3 h-[30rem] w-[30rem] -translate-x-1/2 rounded-full bg-blue-500/10 blur-3xl" />
          </div>
          <div className="relative container mx-auto px-2 md:px-4 lg:px-8">
            <div
              className="max-w-4xl mx-auto text-center"
              data-aos="fade-up"
            >
              <h2 className="text-xl md:text-2xl font-bold text-white/95 mb-4 md:mb-8">
                Transforming Digital Marketing Through Innovation
              </h2>
              <p className="text-xs md:text-sm text-white/70 leading-relaxed">
                At Infuber, we're not just connecting brands with influencers; we're creating a new paradigm for authentic digital engagement and meaningful collaborations.
              </p>
            </div>
          </div>
        </section>

        {/* Our Humble Beginnings Section with Leadership Team */}
        <section className="relative overflow-hidden py-16 sm:py-20 lg:py-24 bg-black">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute -top-44 left-1/2 h-[30rem] w-[30rem] -translate-x-1/2 rounded-full bg-orange-500/10 blur-3xl" />
            <div className="absolute -bottom-44 left-1/3 h-[30rem] w-[30rem] -translate-x-1/2 rounded-full bg-blue-500/10 blur-3xl" />
          </div>
          <div className="relative container mx-auto px-2 md:px-4 lg:px-8">
            <div className="text-center mb-16" data-aos="fade-up">
              <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-white/95">Our Humble Beginnings</h2>
              <p className="text-white/70 text-xs md:text-sm leading-relaxed max-w-3xl mx-auto">
                From a modest startup in a co-working space, Infuber emerged with a single, bold ambition: to connect genuine voices with brands fueled by innovation. Our journey began with passion and perseverance, driven by the belief that authentic connections create lasting impact.
              </p>
            </div>

            <div className="space-y-8 md:space-y-20">
              {/* <div className="rounded-2xl border border-white/10 bg-white/5 p-6 md:p-10 shadow-[0_30px_80px_-40px_rgba(0,0,0,0.9)] backdrop-blur"> */}
                <LeadershipCard
                  name="Anubhav Arora"
                  role="Founder & CEO"
                  description={
                    <>
                      Anubhav brings a strategic global perspective to Infuber as its CEO. An MBA graduate from the prestigious <strong>IIM Bangalore</strong>, Anubhav has led transformative initiatives across <strong>EMEA, the UK, Europe, the US, Africa, Australia, and India</strong>. With a strong foundation in <strong>strategy consulting</strong>, he has helped organizations across the globe scale and adapt in dynamic environments. His leadership at Infuber is focused on driving vision, growth, and innovation at every level.
                    </>
                  }
                  image=""
                  delay="0"
                  isReversed={false}
                />
              {/* </div> */}

              {/* <div className="rounded-2xl border border-white/10 bg-white/5 p-6 md:p-10 shadow-[0_30px_80px_-40px_rgba(0,0,0,0.9)] backdrop-blur"> */}
                <LeadershipCard
                  name="Paramveer Singh"
                  role="Chief Business Officer"
                  description={
                    <>
                      With over a decade of experience in <strong>operations management and enterprise sales</strong> , Paramveer brings operational excellence and customer-first thinking to Infuber. Having worked with top-tier companies like <strong>HCL</strong>, he has a proven track record in scaling businesses, managing complex sales cycles, and building high-performance teams. As our CBO, Paramveer leads all go-to-market initiatives and client success strategies.
                    </>
                  }
                  // image={Paramveer}
                  image=""
                  delay="100"
                  isReversed={true}
                />
              {/* </div> */}

              {/* <LeadershipCard
                name="Himanshu Aggarwal"
                role="Chief Technology Officer"
                description={
                  <> 
                  Himanshu is the technical powerhouse behind Infuber's engineering vision. As a <strong>key architect for several top 100 companies in the UK and US</strong>, he has spent years designing scalable, secure, and innovative systems. With a strong background in enterprise-grade software development, Himanshu ensures that our technology stack is always one step ahead, future-ready, and built to scale.
                  </>
                }
                image=""
                delay="200"
                isReversed={false}
              /> */}

              {/* <LeadershipCard
                name="Ritik Patel"
                role="Head of Engineering"
                description={
                  <>
                  Ritik is a results-driven engineering leader with strong expertise in the <strong>MERN stack</strong> and modern web technologies. As Head of Engineering, he drives end-to-end product development, scalable architecture, and rapid innovation at Infuber. With a proven track record of integrating <strong>AI-powered solutions</strong>, microservices, and secure authentication systems, Ritik ensures technology aligns seamlessly with business goals. His ability to lead small, agile teams while building robust, user-focused platforms makes him a key force in delivering impactful and scalable digital products.
                </>                
                }
                image={Ritik}
                delay="200"
                isReversed={false}
              /> */}
            </div>
          </div>
        </section>

        {/* Core Values Section */}
        <section className="relative overflow-hidden py-16 bg-black">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute -top-44 left-1/3 h-[30rem] w-[30rem] -translate-x-1/2 rounded-full bg-orange-500/10 blur-3xl" />
            <div className="absolute -bottom-44 left-2/3 h-[30rem] w-[30rem] -translate-x-1/2 rounded-full bg-blue-500/10 blur-3xl" />
          </div>
          <div className="relative container mx-auto px-2 md:px-4 lg:px-8">
            <h2 className="text-xl md:text-2xl font-bold text-center mb-4 md:mb-12 text-white/95">Our Core Values</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="rounded-2xl border border-white/10 bg-white/5 p-4 md:p-8 shadow-[0_30px_80px_-40px_rgba(0,0,0,0.9)] backdrop-blur transition-transform duration-300 hover:scale-[1.02]" data-aos="fade-up">
                <div className="flex items-center gap-3 mb-4">
                  <div className="text-orange-500 flex-shrink-0">
                    <FaRocket className="w-12 h-12" />
                  </div>
                  <h3 className="text-xl font-semibold mb-0 text-white/95">Innovation</h3>
                </div>
                <p className="text-white/70">Pushing boundaries and embracing new technologies to revolutionize influencer marketing.</p>
              </div>
              <div className="rounded-2xl border border-white/10 bg-white/5 p-4 md:p-8 shadow-[0_30px_80px_-40px_rgba(0,0,0,0.9)] backdrop-blur transition-transform duration-300 hover:scale-[1.02]" data-aos="fade-up" data-aos-delay="100">
                <div className="flex items-center gap-3 mb-4">
                  <div className="text-orange-500 flex-shrink-0">
                    <FaUsers className="w-12 h-12" />
                  </div>
                  <h3 className="text-xl font-semibold mb-0 text-white/95">Community</h3>
                </div>
                <p className="text-white/70">Building meaningful connections between brands and influencers to create authentic engagement.</p>
              </div>
              <div className="rounded-2xl border border-white/10 bg-white/5 p-4 md:p-8 shadow-[0_30px_80px_-40px_rgba(0,0,0,0.9)] backdrop-blur transition-transform duration-300 hover:scale-[1.02]" data-aos="fade-up" data-aos-delay="200">
                <div className="flex items-center gap-3 mb-4">
                  <div className="text-orange-500 flex-shrink-0">
                    <FaChartLine className="w-12 h-12" />
                  </div>
                  <h3 className="text-xl font-semibold mb-0 text-white/95">Growth</h3>
                </div>
                <p className="text-white/70">Empowering our partners to achieve sustainable growth through data-driven strategies.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Timeline Sections */}
        {/* <section className="py-16 sm:py-20 lg:py-24 bg-gray-50">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="space-y-20">
           
              <div 
                className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
                data-aos="fade-left"
              >
                <div className="lg:order-2">
                  <h2 className="text-3xl font-bold mb-6 text-gray-900">Scaling New Heights</h2>
                  <p className="text-gray-600 text-lg leading-relaxed mb-6">
                    As our innovative platform grew, so did our community of creators and forward-thinking brands. Infuber quickly became synonymous with creativity, driving authentic engagements and collaborative breakthroughs in the digital marketing landscape.
                  </p>
                  <ul className="space-y-4">
                    <li className="flex items-start">
                      <span className="h-2 w-2 bg-orange-500 rounded-full mt-2 mr-3"></span>
                      <div>
                        <h4 className="font-semibold text-gray-900">Expanded Reach</h4>
                        <p className="text-gray-600">50+ brand partnerships and growing</p>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <span className="h-2 w-2 bg-orange-500 rounded-full mt-2 mr-3"></span>
                      <div>
                        <h4 className="font-semibold text-gray-900">Innovation</h4>
                        <p className="text-gray-600">Launched cutting-edge campaign tracking tools</p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="lg:order-1">
                  <img
                    src={Our_Humble_Beginnings}
                    alt="Scaling New Heights"
                    className="w-full h-[400px] object-cover rounded-2xl shadow-xl"
                  />
                </div>
              </div>

        
              <div 
                className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
                data-aos="fade-right"
              >
                <div className="order-2 lg:order-1">
                  <h2 className="text-3xl font-bold mb-6 text-gray-900">Innovating for Tomorrow</h2>
                  <p className="text-gray-600 text-lg leading-relaxed mb-6">
                    With emerging technologies at our fingertips, our commitment to redefining influencer marketing remains unyielding. We're continuously exploring fresh ideas and leveraging cutting-edge technology to pave the way for a future of limitless opportunities.
                  </p>
                  <ul className="space-y-4">
                    <li className="flex items-start">
                      <span className="h-2 w-2 bg-orange-500 rounded-full mt-2 mr-3"></span>
                      <div>
                        <h4 className="font-semibold text-gray-900">AI Integration</h4>
                        <p className="text-gray-600">AI-powered campaign optimization and analytics</p>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <span className="h-2 w-2 bg-orange-500 rounded-full mt-2 mr-3"></span>
                      <div>
                        <h4 className="font-semibold text-gray-900">Real-time Analytics</h4>
                        <p className="text-gray-600">Advanced reporting and performance tracking</p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="order-1 lg:order-2">
                  <img
                    src={Innovating_for_Tomorrow}
                    alt="Innovating for Tomorrow"
                    className="w-full h-[400px] object-cover rounded-2xl shadow-xl"
                  />
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* Stats Section */}
        <section className="relative overflow-hidden py-16 bg-black">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute -top-44 left-1/2 h-[30rem] w-[30rem] -translate-x-1/2 rounded-full bg-orange-500/10 blur-3xl" />
            <div className="absolute -bottom-44 left-1/3 h-[30rem] w-[30rem] -translate-x-1/2 rounded-full bg-blue-500/10 blur-3xl" />
          </div>
          <div className="relative container mx-auto px-2 md:px-4 lg:px-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              <div className="rounded-2xl border border-white/10 bg-white/5 p-4 md:p-6 shadow-[0_30px_80px_-40px_rgba(0,0,0,0.9)] backdrop-blur" data-aos="fade-up">
                <div className="text-2xl md:text-4xl font-bold text-orange-500 mb-2">5+</div>
                <div className="text-white/70">Global Brands</div>
              </div>
              <div className="rounded-2xl border border-white/10 bg-white/5 p-4 md:p-6 shadow-[0_30px_80px_-40px_rgba(0,0,0,0.9)] backdrop-blur" data-aos="fade-up" data-aos-delay="100">
                <div className="text-2xl md:text-4xl font-bold text-orange-500 mb-2">10K+</div>
                <div className="text-white/70">Active Influencers</div>
              </div>
              <div className="rounded-2xl border border-white/10 bg-white/5 p-4 md:p-6 shadow-[0_30px_80px_-40px_rgba(0,0,0,0.9)] backdrop-blur" data-aos="fade-up" data-aos-delay="200">
                <div className="text-2xl md:text-4xl font-bold text-orange-500 mb-2">5+</div>
                <div className="text-white/70">Countries</div>
              </div>
              <div className="rounded-2xl border border-white/10 bg-white/5 p-4 md:p-6 shadow-[0_30px_80px_-40px_rgba(0,0,0,0.9)] backdrop-blur" data-aos="fade-up" data-aos-delay="300">
                <div className="text-2xl md:text-4xl font-bold text-orange-500 mb-2">100k+</div>
                <div className="text-white/70">Monthly Reachs</div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action Section */}
        <section
          className="relative overflow-hidden py-16 bg-black text-white"
          data-aos="fade-up"
        >
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute -top-44 left-1/3 h-[30rem] w-[30rem] -translate-x-1/2 rounded-full bg-orange-500/15 blur-3xl" />
            <div className="absolute -bottom-44 left-2/3 h-[30rem] w-[30rem] -translate-x-1/2 rounded-full bg-blue-500/10 blur-3xl" />
          </div>
          <div className="relative container mx-auto px-2 md:px-4 lg:px-8 text-center">
            <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-white/95">
              Join Us in Shaping the Future
            </h2>
            <p className="text-xs md:text-sm text-white/70 mb-4 md:mb-8 max-w-3xl mx-auto">
              Whether you're a brand looking to make an impact or a creator ready to inspire,
              we're here to help you succeed in the digital age.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-orange-500 text-white px-8 py-3 rounded-lg transition-colors duration-300 text-lg font-medium hover:bg-orange-600">
                Get Started Today
              </button>
              <button className="border border-white px-8 py-3 rounded-lg transition-colors duration-300 text-lg font-medium hover:bg-white hover:text-black">
                Learn More
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default OurStory;